var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import { Field, Form, actions as formActions } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React from 'react';

import { Icon } from "../../UI";
import {
searchDocuments as searchDocumentsAction,
processFilters } from "../actions/libraryActions";

import { t, Translate } from "../../I18N";
import { wrapDispatch } from "../../Multireducer";
import ModalTips from "../../App/ModalTips";
import { SearchTipsContent } from "../../App/SearchTipsContent";
import { submitNewSearch } from "../../SemanticSearch/actions/actions";
import { FeatureToggleSemanticSearch } from "../../SemanticSearch/components/FeatureToggleSemanticSearch";



const mapStateToProps = (state) => {
  const { search, filters } = state.library;
  return {
    initSearch: search,
    initFilters: filters
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
{
  searchDocuments: searchDocumentsAction,
  change: formActions.change,
  semanticSearch: submitNewSearch
},
wrapDispatch(dispatch, 'library'));


const connector = connect(mapStateToProps, mapDispatchToProps);



const SearchBarComponent = ({
  initSearch,
  initFilters,

  searchDocuments,
  change,
  semanticSearch
}) => {
  const search = processFilters(initSearch, initFilters.toJS());
  const resetSearch = () => {
    change('library.search.searchTerm', '');
    const newSearch = _objectSpread({}, search);
    newSearch.searchTerm = '';
    searchDocuments({ search: newSearch }, 'library');
  };

  const submitSemanticSearch = () => {
    semanticSearch(search);
  };

  const doSearch = (newSearch) => {
    searchDocuments({ search: newSearch }, 'library');
  };

  return /*#__PURE__*/(
    _jsx("div", { className: "search-box" }, void 0, /*#__PURE__*/
    _jsx(Form, { model: "library.search", onSubmit: doSearch }, void 0, /*#__PURE__*/
    _jsx("div", { className: `input-group${search.searchTerm ? ' is-active' : ''}` }, void 0, /*#__PURE__*/
    _jsx(Field, { model: ".searchTerm" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      placeholder: t('System', 'Search', null, false),
      "aria-label": t('System', 'Search text description', null, false),
      className: "form-control",
      autoComplete: "off" }), /*#__PURE__*/

    _jsx(Icon, { icon: "times", onClick: resetSearch, "aria-label": "Reset Search input" })), /*#__PURE__*/

    _jsx("button", { type: "submit", className: "search-icon-wrapper" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "search", "aria-label": "Search button" }))), /*#__PURE__*/


    _jsx(FeatureToggleSemanticSearch, {}, void 0, /*#__PURE__*/
    _jsx("button", {
      disabled: !search.searchTerm,
      type: "button",
      onClick: submitSemanticSearch,
      className: "btn btn-success semantic-search-button" }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "flask" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Semantic Search")))), /*#__PURE__*/



    _jsx(ModalTips, {
      label: t('System', 'Search Tips', null, false),
      title: t('System', 'Narrow down your searches', null, false) }, void 0, /*#__PURE__*/

    _jsx(SearchTipsContent, {}))));



};

const container = connector(SearchBarComponent);
export { container as SearchBar };